import { useCallback } from 'react'
import { useIntercom } from 'react-use-intercom'

const SUPPORT_EMAIL_ADDRESS = 'support@pga.com'

const isIntercomBooted = () => !!window?.Intercom?.booted

const buildSupportEmailUrl = message => {
  const bodyQuery = message ? `?body=${encodeURIComponent(message)}` : ''
  return `mailto:${SUPPORT_EMAIL_ADDRESS}${bodyQuery}`
}

const openSupportEmailComposer = message => {
  window.open(buildSupportEmailUrl(message))
}

const useSupportContactActions = () => {
  const {
    show: showIntercom,
    showNewMessage: showNewIntercomMessage,
    startConversation: startIntercomConversation,
    startSurvey: startIntercomSurvey,
  } = useIntercom()

  const openSupport = useCallback(() => {
    if (isIntercomBooted()) {
      showIntercom()
    } else {
      openSupportEmailComposer()
    }
  }, [showIntercom])

  const composeSupportMessage = useCallback(
    message => {
      if (isIntercomBooted()) {
        showNewIntercomMessage(message)
      } else {
        openSupportEmailComposer(message)
      }
    },
    [showNewIntercomMessage],
  )

  const startSupportConversation = useCallback(
    message => {
      if (isIntercomBooted()) {
        startIntercomConversation(message)
      } else {
        openSupportEmailComposer(message)
      }
    },
    [startIntercomConversation],
  )

  const startSupportSurvey = useCallback(
    surveyId => {
      if (isIntercomBooted()) {
        startIntercomSurvey(surveyId)
      } else {
        openSupportEmailComposer()
      }
    },
    [startIntercomSurvey],
  )

  return {
    openSupport,
    composeSupportMessage,
    startSupportConversation,
    startSupportSurvey,
  }
}

export default useSupportContactActions
